<div class="flash-messages-for"
     *ngIf="hasMessages()">
    <div class="alert alert-{{ context }} alert-dismissible"
         *ngFor="let message of messages"
         role="alert">
        <button type="button"
                class="close"
                (click)="close(message.id)"
                aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <strong>{{ message.preface }}</strong>
        {{ message.text }}
    </div>
</div>
